import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";

import { ROLES } from "@/api/admins";
import { useIntegrations } from "@/hooks/use-integrations";
import { useAdminStore } from "@/stores";
import { Breadcrumbs, Button, ScreenContent, ScreenHeader, TabNavigation } from "@/ui";

const BayesiaLayout = () => {
  const { admin } = useAdminStore();
  const { id } = useParams({ strict: false });

  const { isPending, mutate: syncModels } = useIntegrations().syncBayesiaModels();

  return (
    <>
      <ScreenHeader>
        <Breadcrumbs
          items={[
            { label: "Integrations", to: "/integrations" },
            { label: "Bayesia", to: "/integrations/bayesia/inferences" },
            ...(id
              ? [
                  {
                    label: `#${id}`,
                    to: "/integrations/bayesia/inferences/$id",
                    params: { id },
                  } as const,
                ]
              : []),
          ]}
        />

        {admin?.role === ROLES.super && (
          <Button
            isLoading={isPending}
            onClick={() => {
              return syncModels();
            }}
            variant="secondary"
          >
            Sync now
          </Button>
        )}
      </ScreenHeader>

      <ScreenContent>
        <TabNavigation
          tabs={[
            {
              name: "Inferences",
              to: "/integrations/bayesia/inferences",
            },
            {
              name: "Models",
              to: "/integrations/bayesia/models",
            },
          ]}
        />

        <div className="pt-4">
          <Outlet />
        </div>
      </ScreenContent>
    </>
  );
};

export const Route = createFileRoute("/_private/integrations/bayesia")({
  component: BayesiaLayout,
});
